import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewSatisfactionChecksActions from '../review-satisfaction-checks/review-satisfaction-checks.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewSatisfactionChecksStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewSatisfactionChecksActions.ReviewSatisfactionChecksRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_SATISFACTION_CHECKS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewSatisfactionChecksActions.ReviewSatisfactionChecksCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewSatisfactionChecksActions.ReviewSatisfactionChecksUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewSatisfactionChecksActions.ReviewSatisfactionChecksDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewSatisfactionChecksActions.ReviewSatisfactionChecksRefresh());
          break;
      }
    });
  }
}
